import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_COST_CENTRES);
var axios_instance2 = get_axios_instance(api_variables.SERVICE_DOWNLOAD_API); 

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, [payload, le_id]) => {
        if (le_id) {
            state.data[le_id] = payload;
            state.data = {...state.data }
        }
    },
    clear: (state, le_id) => {
        state.data[le_id] = []
    },
    addEntity: (state, [payload, id]) => {
        if (!state.data[id]) {
            state.data[id] = [...payload]
        } else {
            state.data[id] = [...state.data[id], ...payload]
        }
    },

    updateEntityById: (state, [payload, le_id]) => {
        for (let i = 0; i < state.data[le_id].length; i++) {
            if (state.data[le_id][i][_pk_name] === payload.id) {
                state.data[le_id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, le_id]) => {
        for (let i = 0; i < state.data[le_id].length; i++) {
            if (state.data[le_id][i][_pk_name] == payload) {
                state.data[le_id].splice(i, 1);
            }
        }
        if (state.data[le_id].length == 0)
            state.data = {}
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        //console.log("payload---", payload.record);
        //  //console.log("record---" + record);
        state.editMode = payload.editMode;
        state.record = payload.record;
    }

}

const actions = {
    async fetchAll({ commit }, queryObj) {
        //console.log("[state/organisation/utility/crudit/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance.get('', {
                params: {...queryObj }
            });
            commit("setFetching", false);
            //console.log("[state/organisation/utility/crudit/fetchAll] res: ", res);
            if (res.status == 200 || res.status == 201) {
                //console.log(res.data.payload.data.length)
                // commit("set", [res.data.payload.data,le_id]);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async downloadC({ commit }, payload) {
        //console.log("[state/dashboard/organisation/utilities/smtp/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance2.get(`/`, {
                params: {
                    id: payload
                }
            });
            commit("setFetching", false);
            //console.log("[state/dashboard/organisation/utilities/smtp/fetchAll] res: ", res);
            // if (res.status == 200) {
            //     //console.log('rows data', res.data.rows)
            //     commit("set", res.data.rows);
            // }

            return res;
        } catch (error) {
            //console.log('error',error);
            
        }
    },

    async create({ commit }, payload) {
        //console.log("[state/organisation/utility/crudit/create] Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            //console.log("[state/organisation/utility/crudit/create] res: ", res);
            if (res.status == 200 || res.status == 201) {
                commit("addEntity", [res.data.payload, payload.le_id]);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, [payload, le_id]) {
        //console.log("[state/organisation/utility/crudit/update] Updating... Display payload", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.put('', payload);
            commit("setSaving", false);
            //console.log("[state/organisation/utility/crudit/update] res: ", res);
            if (res.status == 200) {
                commit("updateEntityById", [res.data, le_id]);
            }
            return res;
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, le_id]) {
        //console.log("[state/organisation/utility/crudit/delete] Payload:", payload);
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, le_id]);
            }
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },


    async changeEditMode({ commit }, payload) {
        // //console.log(
        //     "[state/onboard/designations/changeEditMode] Payload:",
        //     payload
        // );
        try {
            commit("setEditMode", payload);
        } catch (error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}